/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SOCKET = feature.getSettingValue('SOCKET');
    const socketFeature = project.getFeature(SOCKET);
    if (!socketFeature) {
        return blocks;
    }
    const NAME = socketFeature.getSettingValue('NAME');
    const SERVERIP = socketFeature.getSettingValue('SERVERIP');
    const SERVERPORT = socketFeature.getSettingValue('SERVERPORT');

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `/****${doneLinks[0].getSourceId()}****/` : '';
    const links = project.getNodeLinks(feature, 'connect');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
if (net_if_ready) {
    if (${NAME}_SOCK_NUM < 0) {
        ${NAME}_SOCK_NUM = socket(AF_INET, SOCK_STREAM, 0);
    }
    if (${NAME}_SOCK_NUM < 0) {
        LOG_INF("Socket creation failed");
    } else {
        struct sockaddr_in server_addr;
        server_addr.sin_family = AF_INET;
        server_addr.sin_port = htons(${project.parseCodeExpression(SERVERPORT, [], TibboDataType.INTEGER)});
        string server_ip = ${project.parseCodeExpression(SERVERIP, [], TibboDataType.STRING)};
        net_addr_pton(AF_INET, server_ip.c_str(), &server_addr.sin_addr);
        int ret = connect(${NAME}_SOCK_NUM, (struct sockaddr *)&server_addr, sizeof(server_addr));
        if (ret < 0) {
            LOG_INF("Connection failed");
            ${NAME}_SOCK_NUM = -1;
        } else {
            LOG_INF("Connection successful");
            k_thread_start(${NAME}_sock_tid);
        }
    }
}
${doneBlock}`,
        });
    }

    return blocks;
};
